import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawal } from '@/types/vehicle-withdrawal'
import { AxiosResponse } from 'axios'

export function createVehicleWithdrawal(
  body: Partial<VehicleWithdrawal>
): Promise<
  AxiosResponse<Omit<VehicleWithdrawal, 'ford'> & { ford: string | null }>
> {
  return instance.post(`/vehicle-withdrawal`, {
    ...body,
    ford: body.ford?.length ? body.ford?.join(',') : null,
  })
}
